// Model Service - Fetch models dynamically from backend

class ModelService {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL || 'https://api.daggpt.network';
    this.cache = {
      chat: null,
      image: null,
      video: null,
      music: null,
      code: null,
      research: null
    };
  }

  async getModelsByFunction(functionName) {
    try {
      // Return cached if available
      if (this.cache[functionName]) {
        return this.cache[functionName];
      }

      // Fetch from Worker - returns { chatModels: { "Provider: Name": {...} }, musicModels: {} }
      const response = await fetch(`${this.baseURL}/api/models`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to fetch models');
      }

      if (data.success) {
        // Convert chatModels object → array
        const chatArray = Object.values(data.chatModels || {});
        const musicArray = Object.values(data.musicModels || {});
        const allModels = [...chatArray, ...musicArray];

        // Filter to the requested function category
        const filtered = allModels.filter(m =>
          m.category === functionName ||
          (m.functions && m.functions.includes(functionName))
        );

        this.cache[functionName] = filtered;
        return filtered;
      }

      return [];
    } catch (error) {
      console.error(`Error fetching ${functionName} models:`, error);
      return [];
    }
  }

  clearCache() {
    this.cache = {
      chat: null,
      image: null,
      video: null,
      music: null,
      code: null,
      research: null
    };
  }

  async refreshModels() {
    this.clearCache();
    // Pre-fetch all function types
    await Promise.all([
      this.getModelsByFunction('chat'),
      this.getModelsByFunction('image'),
      this.getModelsByFunction('video'),
      this.getModelsByFunction('music'),
      this.getModelsByFunction('code'),
      this.getModelsByFunction('research')
    ]);
  }
}

const modelService = new ModelService();
export default modelService;
